export const saveAnswer = async (dataAnswer) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/analytics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataAnswer),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        //console.log(data);
    } catch (error) {
        console.error('Error:', error);
    }
};


export const saveFootprint = async (dataFootprint) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/footprint`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataFootprint),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        //console.log(data);
    } catch (error) {
        console.error('Error:', error);
    }
};
